export const utmParamPairsForSimplifiedLayout = [
  { utmMedium: 'cpm', utmSource: 'facebook' },
  {
    utmMedium: 'ppc',
    utmSource: 'google',
  },
  { utmMedium: 'ppc', utmSource: 'yahoo' },
  { utmMedium: 'cpc', utmSource: 'yahoo' },
  { utmMedium: 'email', utmSource: 'zehitomo' },
  { utmMedium: 'cpc', utmSource: 'bing' },
];
